import React from 'react';
import './SectionBanner.css';

const SectionBanner = ({ className = '', onClick }) => {
  return (
    <div className={`section-banner ${className}`} onClick={onClick}>
      <div className="banner-background">
        <img 
          src="/assets/images/maincourse.png"
          alt="Основной курс"
          className="banner-image banner-image-loaded high-quality-image"
          loading="lazy"
          decoding="async"
          onLoad={(e) => {
            // Плавно показываем изображение после загрузки
            if (e.target) {
              requestAnimationFrame(() => {
                e.target.style.opacity = '1';
              });
            }
          }}
          onError={(e) => {
            // Fallback при ошибке загрузки изображения
            console.warn('Failed to load banner image');
            if (e.target) {
              e.target.style.display = 'none';
            }
          }}
        />
        <div className="banner-content">
          <div className="section-overlay">
            <h3 className="banner-title">Основной курс</h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionBanner; 